<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>    
                <h6 class="modal-subtitle mb-0">
                    {{subtitle}}
                </h6>    
            </div>
            <div class="modal-body">
               <form #form="ngForm" novalidate>
                    <sgt-loading-info
                        *ngIf="isLoading"
                        title="Carregando as unidades de negócios"
                        text="Aguarde um momento enquanto estamos carregando as unidades de negócios">
                    </sgt-loading-info> 

                    <ng-template [ngIf]="isLoadingFinished">
                         <div class="row" *ngIf="possuiUnidadesNegocios()">
                            <div class="col-12">
                                <ul class="list-group">
                                    <li class="list-group-item" *ngFor="let entityPopula of entitiesPopula; let index = index"
                                        [class.exists]="entityPopula.exists">
                                        {{entityPopula.unidadeNegocio?.nome}}

                                        <div class="custom-control custom-switch float-right" *ngIf="!entityPopula.exists">
                                            <input type="checkbox" class="custom-control-input" [(ngModel)]="entityPopula.selected" name="entityPopulaSelected_{{index}}" id="entityPopulaSelected_{{index}}"
                                               (ngModelChange)="onChangeSelected()">
                                            <label class="custom-control-label" for="entityPopulaSelected_{{index}}"></label>
                                        </div>     
                                        <div class="float-right label-exists" *ngIf="entityPopula.exists">
                                            Já adicionada
                                        </div>                                    
                                    </li>
                                </ul>                          
                            </div>
                        </div>
     
                        <div class="alert alert-info alert-no-entities" *ngIf="!possuiUnidadesNegocios()">
                             <h5>
                                <i class="fas fa-info" aria-hidden="true"></i> Nenhuma unidade de negócio cadastrada
                             </h5>
                             <p>É necessário cadastrar as unidades de negócios para poder adicionar</p>
                         </div>
                    </ng-template>
                                
               </form>
            </div>
            <div class="modal-footer">
                <div class="modal-footer-controls">
                    <div class="custom-control custom-switch float-left" *ngIf="possuiUnidadesNegocios()">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="allSelected" name="allSelected" id="allSelected"
                            (ngModelChange)="onChangeAllSelected($event)">
                        <label class="custom-control-label" for="allSelected">Selecionar todas unidades de negócios</label>
                    </div>
                </div>

                <div class="modal-footer-btns">
                    <button type="button" class="btn btn-light mr-2" (click)="close()">
                        Cancelar
                    </button>
                    <button type="button" class="btn btn-primary" (click)="adicionarClick()" id="btnAdicionarUnidadeNegocioPopulaModal" *ngIf="possuiUnidadesNegocios()">
                        Adicionar
                    </button>                
                </div>
            </div>            
        </div>
    </div>
</div>